exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".framely-sql-ide {\n  width: 100%;\n  height: 60px;\n}\n.framely-sql-ide .monaco-editor {\n  box-sizing: border-box;\n  border: 1px solid #D7D7DE;\n  border-radius: 6px;\n  overflow: hidden;\n}\n", ""]);

// exports
